

import { Noti } from '../components/Noti/toast'

export const handleCopy = (text?: string) => {
    navigator.clipboard.writeText(text || "");
    Noti('success', "Copied successfully", 3000)
};
